/**
 * Turns query string like hello=1&another=2 into object {hello: 1, another: 2}
 * @param {*} queryString
 */
function parseQuery(queryString) {
  var query = {};
  var pairs = (
    queryString[0] === "?" ? queryString.substring(1) : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

function modifyColor(col, amt) {
  var usePound = false;

  if (col[0] == "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (
    (usePound ? "#" : "") +
    String("000000" + (g | (b << 8) | (r << 16)).toString(16)).slice(-6)
  );
}

function addAlpha(color, opacity) {
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
}

function parsePrice(price, thousandSeparator, decimalSeparator) {
  const regEx = new RegExp(
    `([0-9${thousandSeparator}]+)(\\${decimalSeparator}\\d+)?`
  );
  const [_ignored, int, decimals] = price.match(regEx);
  return parseFloat(
    `${int.replace(/[^0-9]/g, "")}.${(decimals || "0").replace(/[^0-9]/g, "")}`
  );
}

function checkGTM() {
  return (
    typeof window.google_tag_manager !== "undefined" &&
    typeof window.dataLayer !== "undefined"
  );
}

const updateDataLayer = (datalayerFunction) => {
  const interval = setInterval(async () => {
    if (checkGTM()) {
      window.dataLayer = window.dataLayer ?? [];
      window.dataLayer.push({ ecommerce: null });
      await datalayerFunction();
      clearInterval(interval);
    }
  }, 200);
};

function withBase(base, p = "") {
  const b = String(base || "").replace(/\/$/, "");
  const s = String(p || "").replace(/^\//, "");
  return s ? `${b}/${s}` : b || "";
}
function imageUrl(node) {
  return node?.sourceUrl || node?.localFile?.publicURL || null;
}
function stripHtml(html) {
  return html ? html.replace(/<\/?[^>]+(>|$)/g, "").trim() : "";
}
function slugFromUri(uri) {
  if (!uri) return "";
  return String(uri)
    .replace(/^\/|\/$/g, "")
    .split("/")
    .pop();
}
function getWriterPath({ slug, crbRoleTitle } = {}) {
  const rolePrefix =
    (crbRoleTitle || "").toLowerCase() === "tannlege"
      ? "tannlege-"
      : "tannlege-";
  return `/om-oss/${rolePrefix}${slug || ""}/`;
}

module.exports = {
  parseQuery,
  addAlpha,
  modifyColor,
  parsePrice,
  updateDataLayer,
  withBase,
  imageUrl,
  stripHtml,
  slugFromUri,
  getWriterPath,
};
